import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'
import Text from './index'

export const HourDropdownText = styled(Text)`
    width: 45px;
    @media ${respondAbove.xl} {
        width: 52px;
    }
`
